import validate from "/opt/dasei/source/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.5.0_@types+node@20.17.6_encoding@0.1.13_eslint@8.57.1_ioredis@5_oogdwkfncumbysopzqdpvczk4i/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/dasei/source/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.5.0_@types+node@20.17.6_encoding@0.1.13_eslint@8.57.1_ioredis@5_oogdwkfncumbysopzqdpvczk4i/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}